import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr";
import en from "./locales/en";

const STORAGE_KEY = "pulaar-lang";

const detectInitial = () => {
  if (typeof window === "undefined") return "fr";
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "fr" || stored === "en") return stored;
  } catch (_) {
    /* ignore */
  }
  // Default: French (Pulaar is a French house)
  return "fr";
};

i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en } },
  lng: detectInitial(),
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export const setLanguage = (lng) => {
  i18n.changeLanguage(lng);
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
  } catch (_) {
    /* ignore */
  }
};

export default i18n;
